<app-header></app-header>
<div class="page-container">
  <router-outlet></router-outlet>
</div>